export const dpsInitialState = {
    dpsDataAll: [],
    dpsTableData: [],
    addDPSData: {},
    editDPSData: {},
    totalCount: 0,
    trfMasterList: [],
    dpsSearchString: '',
    unSavedChanges: false,
    sapFloc: '',
    sortDisplayStatusAscOrder: true,
    sortFunctionalLocationAscOrder: true,
    sortColumn: 'SapFloc',
    sapFlocExist: false,
    dpsLockedFields: [],
    correctiveDPSMapping: [],
    dpsMaxLengthMapper: {}
};

export const dpsFormState = (regionName, assetName) => ({
    Region: regionName,
    Asset: assetName,
    SapFloc: '',
    LocationDescription: '',
    Manufacturer: '',
    Model: '',
    Service: '',
    ToleranceInInstrumentEu: '',
    IcssSoftTag: '',
    DeviceType: '',
    FailureModeHighCurrentMA: '',
    FailureModeLowCurrentMA: '',
    HmiEngineeringUnits: '',
    HmiLrv: '',
    HmiUrv: '',
    InstrumentCalibratedLrv: '',
    InstrumentCalibratedUrv: '',
    InstrumentEngineeringUnits: '',
    ReCalibrationTolerance: '',
    TrfId: '',
    TrfDesc: '',
    DeckHullBldg: '',
    Quad: '',
    Level: '',
    Room: '',
    Location2: '',
    DesignElementResponseTime: '',
    TargetLeakageClass: '',
    TargetLeakageRate: '',
    HighHighSetpoint: '',
    LowLowSetpoint: '',
    FailTolerance: '',
    Span: '',
    Manufacturer2: '',
    Manufacturer3: '',
    Manufacturer4: '',
    Manufacturer5: '',
    Manufacturer6: '',
    Manufacturer7: '',
    Model2: '',
    Model3: '',
    Model4: '',
    Model5: '',
    Model6: '',
    Model7: '',
    SetPointHigh: '',
    Status: 'Active',
    Comment: '',
    F4CompletedBy: '',
    F5DateTested: '',
    F4ModifiedBy: '',
    F51DateLastModified: '',
    ReCalibrationToleranceEU: '',
    FailToleranceEU: '',
    HighHighSetpointComment: '',
    LowLowSetpointComment: '',
    CorrectiveTrfId: '',
    CorrectiveTrfDesc: '',
    Doc1Url: '',
    Doc2Url: '',
    Doc1Number: '',
    Doc2Number: '',
    ToleranceInInstrumentEUComment: '',
    LowSetpointComment: '',
    HighSetpointComment: '',
    SwitchSetpoint: '',
    SwitchSetpointComment: '',
    TargetLeakageRateEu: '',
    ValveSize: '',
    InspectionIrfId: '',
    InspectionIrfDescription: '',
    Class: '',
    GasGroup: '',
    Zone: '',
    Division: '',
    TemperatureClass: '',
    EquipmentProtectionLevel: '',
    ValveID: '',
    ValvePressureClass: '',
    ValveSizeNPS: '',
    ValveLeakageRateEU: '',
    NitrogenPsvReliefCapacity: '',
    WaterPsvReliefCapacity: '',
});

export const colorLegendDps = [
    { id: 1, color: 'rgb(255, 255, 0)', description: 'Mandatory fields to be filled by user to submit the record' },
    { id: 2, color: 'rgb(255, 229, 175)', description: 'Mandatory fields with data' },
    { id: 3, color: 'rgb(0, 176, 80)', description: 'Fields that are required on one or many forms' },
    { id: 4, color: 'rgb(231, 246, 213)', description: 'Required fields in the form for selected TRF ID' },
    { id: 5, color: 'rgb(240, 244, 255)', description: 'Required fields in the form for selected Corrective ID' },
    { id: 6, color: 'rgb(241, 219, 255)', description: 'Required fields in the form for selected Inspection ID' },
    { id: 7, color: 'rgb(232, 232, 232)', description: 'Read Only Field/Data to be populated from different source' },
    { id: 8, color: 'rgb(255, 255, 255)', description: 'Optional fields' }
];
